import React, {CSSProperties, useCallback, useRef, useState} from 'react'
import {useClickInside, useClickOutside} from '../../../../app/features'
import {Tooltip, Whisper} from 'rsuite'
import {KTSVG} from '../../../helpers'

type Props = {
  description: string
  index: number
}

export function Dropdown5({description, index}: Props) {

  const ref = useRef<HTMLDivElement | null>(null)
  const buttonRef = useRef<HTMLButtonElement | null>(null)
  const [toggle, setToggle] = useState<boolean>(false)

  useClickInside(ref, () => {
    if (!toggle) setToggle(true)
  })

  useClickOutside(ref, () => {
    if (toggle) setToggle(false)
  })

  const Styles = useCallback(
    (index: number): CSSProperties => {
      if (index === 0 || index === 1) {
        return {
          zIndex: 105,
          position: 'absolute',
          margin: 0,
          top: '35px',
          right: '25px',
        }
      }
      return {
        zIndex: 105,
        position: 'absolute',
        margin: 0,
        bottom: '35px',
        right: '25px',
      }
    },
    [])

  return (
    <div className="position-relative d-flex justify-content-center align-content-center" ref={ref}>
      {/* begin::Menu */}
      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Description</Tooltip>}>
        <button
          type="button"
          className={`btn btn-sm btn-icon btn-color-info btn-active-light-info ${toggle ? 'show menu-dropdown' : ''}`}
          data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="top-end"
          ref={buttonRef}
        >
          <KTSVG path={`/media/icons/duotune/general/gen005.svg`} className="svg-icon-3" />
        </button>
      </Whisper>

      <div
        className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-250px ${toggle ? 'show ' : ''}`}
        style={toggle ? Styles(index) : {}}
      >
        <div className="menu-item bg-light-warning">
          <div className="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">
            {description}
          </div>
        </div>
      </div>
    </div>
  )

}